import {Settings} from './settings.base';

export class SettingsProduction extends Settings {
  BASE_URL = 'https://www.brainkey.ai';
}
